import {api} from "../../shared/utils";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;

const demoProfile = {
    userId: 'demo',
    username: 'demo',
    email: 'demo@busifarm.com.br',
    ddiPhoneNumber: '55',
    mobilePhoneNumber: '87999999999',
    enabled: true,
    blocked: false,
    mustRenewPassword: false,
    specialAccessType: 'DEMO',
    roles: [],
    licenses: [],
    createdAt: null,
    updatedAt: null,
    createdBy: 'LOCAL',
    userAllowedToWork: true,
    reasonToNotAllowed: null,
    accountExpired: false,
};

export const getProfile = () => environment.disableAuth
    ? Promise.resolve({data: {valor: demoProfile}})
    : api.get(`${baseUrl}/auth/users/me`);
